const sentEvents = {};

const Bicentury_GA = {
	sendEvent: function(category, action, label, justOnce = false){
		const sentEventId = `${category}_${action}_${label}`;
		if(!justOnce || !sentEvents[sentEventId]){
			console.log(`Sending event with category: ${category}, action: ${action}, label: ${label}`);
			if(window.ga){
				window.ga('send', 'event', category, action, label);		
			}
			else{
				console.log('ERROR. "window.ga" is not defined');
			}
			
		}
		else{
			console.log(`NOT sending event with category: ${category}, action: ${action}, label: ${label} since it has already been sent`);
		}
		sentEvents[sentEventId] = true;
	},

	sendPageView: function(location){
		console.log('Sending pageview', location.pathname + location.search + location.hash);
		if(window.ga){
			window.ga("set", "page", location.pathname + location.search + location.hash);
			window.ga("send", "pageview");					
		}
		else{
			console.log('ERROR. "window.ga" is not defined');
		}
	}
}

export default Bicentury_GA;


// WEBPACK FOOTER //
// ./src/utils/analytics.js